import { createReducer, on } from '@ngrx/store';

import { OverviewState } from '../../models/overview.model';
import * as OverviewActions from '../actions/overview.actions';

export const initialState: OverviewState = {
  labResults: null,
};

export const reducer = createReducer<OverviewState>(
  initialState,
  on(OverviewActions.loadLabResultsSuccess, (state, { labResults }) => ({
    ...state,
    labResults,
  })),
);
